import { render, staticRenderFns } from "./PublicApiIndex.vue?vue&type=template&id=304410f8&"
import script from "./PublicApiIndex.vue?vue&type=script&lang=ts&"
export * from "./PublicApiIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports